// src/components/layout/Navbar.tsx

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { logout } from '../../store/slices/authSlice';
import { fullName, initials } from '../../utils/format';

interface Props {
  collapsed: boolean;
  onMobileToggle: () => void;
}

const TITLES: { prefix: string; icon: string; title: string }[] = [
  { prefix: '/dashboard', icon: 'bi-grid-1x2-fill', title: 'Dashboard' },
  { prefix: '/usuarios', icon: 'bi-people-fill', title: 'Usuarios' },
  { prefix: '/cupones', icon: 'bi-ticket-perforated-fill', title: 'Cupones' },
];

export default function Navbar({ collapsed, onMobileToggle }: Props) {
  const user = useAppSelector((s) => s.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const current = TITLES.find((t) => pathname.startsWith(t.prefix));

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <header className={`navbar-dashboard ${collapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Hamburger — solo en móvil */}
      <button
        className="btn btn-link p-0 d-lg-none me-2"
        onClick={onMobileToggle}
        style={{ color: 'var(--tp-primary)', fontSize: '1.4rem', lineHeight: 1 }}
        title="Abrir menú"
      >
        <i className="bi bi-list" />
      </button>

      {/* Título de la página */}
      <div className="navbar-brand">
        <i className={`bi ${current?.icon ?? 'bi-shield-check'}`} style={{ color: 'var(--tp-green)' }} />
        <span>{current ? current.title : 'Panel Administrativo'}</span>
      </div>

      <div className="navbar-spacer" />

      {/* Usuario */}
      <div className="navbar-user dropdown">
        <div
          className="d-flex align-items-center gap-2"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ cursor: 'pointer' }}
        >
          <div className="avatar">
            {user?.imagePath ? (
              <img src={user.imagePath} alt="" />
            ) : (
              initials(user?.firstName, user?.lastName, 'A')
            )}
          </div>
          <div className="user-info d-none d-sm-block">
            <div className="user-name">{fullName(user?.firstName, user?.lastName, user?.username ?? '')}</div>
            <div className="user-role">Administrador</div>
          </div>
          <i className="bi bi-chevron-down d-none d-sm-block" style={{ fontSize: '0.75rem', color: 'var(--tp-muted)' }} />
        </div>
        <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ borderRadius: 12, minWidth: 200 }}>
          <li>
            <span className="dropdown-item-text" style={{ fontSize: '0.8rem', color: 'var(--tp-muted)' }}>
              {user?.email}
            </span>
          </li>
          <li><hr className="dropdown-divider" /></li>
          <li>
            <button className="dropdown-item text-danger d-flex align-items-center gap-2" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right" />
              Cerrar sesión
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}
